<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-2">
        <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-1">
        <div class="col-12">
            <h4 class="mb-2 py-1 font-header-1">Manage Service</h4>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pb-0 pt-2 mb-4">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <nav>
                                <div class="nav nav-tabs nav-fill " id="nav-tab" role="tablist">

                                    <a class="nav-item nav-link active" id="nav-tax-tab" data-bs-toggle="tab"
                                        href="#nav-service-group" role="tab"
                                        [ngClass]="{'mytab-inactive':ManageServiceTab!='nav-service-group','active':ManageServiceTab=='nav-service-group' }"
                                        aria-controls="nav-tax" aria-selected="true"
                                        (click)="tabChanged('nav-service-group')">Service Group</a>

                                    <a class="nav-item nav-link " id="nav-service-tab" data-bs-toggle="tab"
                                        href="#nav-service" role="tab"
                                        [ngClass]="{ 'mytab-inactive':ManageServiceTab!='nav-service','active':ManageServiceTab=='nav-service'}"
                                        aria-controls="nav-service" aria-selected="false"
                                        (click)="tabChanged('nav-service')">Service </a>

                                    <a class="nav-item nav-link " id="nav-activity-tab" data-bs-toggle="tab"
                                        href="#nav-activity" role="tab"
                                        [ngClass]="{'mytab-inactive':ManageServiceTab!='nav-activity','active':ManageServiceTab=='nav-activity' }"
                                        aria-controls="nav-activity" aria-selected="true"
                                        (click)="tabChanged('nav-activity')">Activity</a>

                                    <a class="nav-item nav-link " id="nav-service-activity-tab" data-bs-toggle="tab"
                                        href="#nav-service-activity" role="tab"
                                        [ngClass]="{'mytab-inactive':ManageServiceTab!='nav-service-activity','active':ManageServiceTab=='nav-service-activity' }"
                                        aria-controls="nav-service-activity" aria-selected="true"
                                        (click)="tabChanged('nav-service-activity')">ServiceActivityMapping</a>
                                        <a class="nav-item nav-link " id="nav-service-tax-activity-tab" data-bs-toggle="tab"
                                        href="#nav-service-tax-activity" role="tab" *ngIf="this.global.agencyCode == 'SUPERADMIN'"
                                        [ngClass]="{'mytab-inactive':ManageServiceTab!='nav-service-tax-activity','active':ManageServiceTab=='nav-service-tax-activity' }"
                                        aria-controls="nav-service-activity" aria-selected="true"
                                        (click)="tabChanged('nav-service-tax-activity')">ServiceTaxMapping</a>

                                </div>
                            </nav>
                            <div class="tab-content" id="nav-tabContent">
                                <!-- service-group -->
                                <div class="tab-pane fade  " id="nav-service-group" role="tabpanel"
                                    aria-labelledby="nav-service-group"
                                    [ngClass]="{'active':ManageServiceTab=='nav-service-group','show':ManageServiceTab=='nav-service-group'}">

                                </div>
                            </div>
                            <!-- service -->
                            <div *ngIf="ManageServiceTab=='nav-service'">
                                <div class="tab-pane fade" id="nav-service" role="tabpanel"
                                    aria-labelledby="nav-service"
                                    [ngClass]="{'active':ManageServiceTab=='nav-service','show':ManageServiceTab=='nav-service'}">
                                </div>
                            </div>

                            <div *ngIf="ManageServiceTab=='nav-activity'">
                                <div class="tab-pane fade" id="nav-activity" role="tabpanel"
                                    aria-labelledby="nav-activity"
                                    [ngClass]="{'active':ManageServiceTab=='nav-activity','show':ManageServiceTab=='nav-activity'}">
                                </div>
                            </div>

                            <div *ngIf="ManageServiceTab=='nav-service-activity'">
                                <div class="tab-pane fade" id="nav-service-activity" role="tabpanel"
                                    aria-labelledby="nav-service-activity"
                                    [ngClass]="{'active':ManageServiceTab=='nav-service-activity','show':ManageServiceTab=='nav-service-activity'}">

                                </div>
                            </div>
                            <div *ngIf="ManageServiceTab=='nav-service-tax-activity'">
                                <div class="tab-pane fade" id="nav-service-tax-activity" role="tabpanel"
                                    aria-labelledby="nav-service-tax-activity"
                                    [ngClass]="{'active':ManageServiceTab=='nav-service-tax-activity','show':ManageServiceTab=='nav-service-tax-activity'}">

                                </div>
                            </div>
                        </div>
                        <app-service-group *ngIf="isViewServiceGroup">
                        </app-service-group>

                        <app-service *ngIf="isViewService">
                        </app-service>


                        <app-service-activity *ngIf="isViewServiceActivityMapping">

                        </app-service-activity>


                        <app-activity *ngIf="isViewActivity">

                        </app-activity>
                        <app-service-tax *ngIf="isViewServiceTaxMapping">

                        </app-service-tax>
                        

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- ejs-grid -->
<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class="col p-0">
        <div widget class="card border-0 box-shadow">

        </div>
    </div>
</div>